import React, { useEffect } from "react";
import * as R from "ramda";

import { FORM_INSTANCE_ID } from "../constants";

import { WithFormInstanceProvider } from "ui-kit/Form/View";

import { useMobile } from "Portal/NewPortal/Shared/UseMobile";

import DefaultView from "./DefaultView";
import MobileView from "./MobileView";

import { connect } from "react-redux";
import { actions } from "../model";

import { noop } from "utils/General";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(FORM_INSTANCE_ID)),
  connect(() => ({}), { init: actions.init })
);

const Body = ({ init = noop }) => {
  useEffect(() => {
    init();
  }, []);
  const isMobile = useMobile();
  return (
    <>
      {isMobile && <MobileView />}
      {!isMobile && <DefaultView />}
    </>
  );
};

export default decorate(Body);
